import React from 'react';
import { Field } from 'formik';
import { TextField } from 'formik-material-ui';
import { Grid, SearchSelect, makeStyles } from '../../../..';
import selects from '../../../../assets/selects';
var useStyles = makeStyles(function (theme) {
  return {
    root: {
      display: 'flex',
      'flex-wrap': 'wrap'
    },
    info: {
      display: 'flex',
      'justify-content': 'flex-start',
      'padding': '15px',
      'align-items': 'baseline'
    },
    client: {
      'min-width': '30%'
    },
    mr15: {
      'margin-right': '30px'
    },
    minw10: {
      'min-width': '10%'
    },
    w25: {
      width: '25%'
    }
  };
});

var BillingSeriesForm = function BillingSeriesForm(_ref) {
  var mode = _ref.mode,
      translation = _ref.translation,
      values = _ref.values;
  var classes = useStyles();
  return [/*#__PURE__*/React.createElement(Grid, {
    item: true,
    md: 12,
    className: classes.info
  }, /*#__PURE__*/React.createElement(Field, {
    "data-cy": "name",
    name: "name",
    key: "name",
    label: translation ? translation.inputs.name : "Name",
    component: TextField,
    className: classes.mr15,
    variant: "outlined",
    disabled: mode === "view"
  }), /*#__PURE__*/React.createElement(Field, {
    "data-cy": "type",
    name: "type",
    key: "type",
    component: SearchSelect,
    placeholder: translation ? translation.selects.type.placeholder : "Type",
    className: [classes.w25, classes.mr15].join(" "),
    options: translation ? translation.selects.type.items : selects.series_types,
    clickable: mode !== "view"
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    md: 12,
    className: classes.info
  }, /*#__PURE__*/React.createElement(Field, {
    "data-cy": "prefix",
    name: "prefix",
    key: "prefix",
    label: translation ? translation.inputs.prefix : "Prefix",
    component: TextField,
    className: classes.mr15,
    variant: "outlined",
    disabled: mode === "view"
  }), /*#__PURE__*/React.createElement(Field, {
    "data-cy": "sufix",
    name: "sufix",
    key: "sufix",
    label: translation ? translation.inputs.sufix : "Sufix",
    component: TextField,
    className: classes.mr15,
    variant: "outlined",
    disabled: mode === "view"
  }), /*#__PURE__*/React.createElement(Field, {
    "data-cy": "lastInvoice",
    name: "lastInvoice",
    key: "lastInvoice",
    label: translation ? translation.inputs.last_invoice : "Last invoice num",
    component: TextField,
    type: "number",
    className: classes.mr15,
    variant: "outlined",
    disabled: mode === "view"
  }))];
};

export { BillingSeriesForm };